import React from "react";
import { LoaderProps } from "shared/Loader/types";
import "./index.scss";

const Loader: React.FC<LoaderProps> = ({ showOverlay, height = "100vh" }) => {
  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        marginTop: showOverlay ? "0px" : "20px",
        background: showOverlay ? "rgba(0,0,0,.75)" : "",
        position: showOverlay ? "fixed" : "relative",
        height: showOverlay ? height : "unset",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1002,
        top: 0,
      }}
    >
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
